//import validator from 'validator';
import isEmail from 'validator/es/lib/isEmail';
import isEmpty from 'validator/es/lib/isEmpty';
import isMobilePhone from 'validator/es/lib/isMobilePhone';
import Popup from '../popup/popup';
import request from 'oc-request';

export default new class Form {
    constructor() {
        this.sFormClass = 'form';
        this.sFormUpdatePasswordClass = '_form-lk-password';
        this.sFormResetPasswordClass = '_form-lk-reset-password';
        this.sFormOrderCheckoutClass = '_form-lk-order-checkout';
        this.sFormRegistrationClass = '_form-lk-registration';
        this.sFormAuthClass = '_form-lk-auth';
        this.sFormOrganizationTypeClass = '[name="organization_type"]';
        this.sFormOrganizationFileldsClass = '_form-lk-organization-filelds';
        this.sFormRequestDemoClass = '_form-request-demo';
        this.sFormPersonalDataClass = '_form-lk-data';
        this.sFormRestorePasswordClass = '_form-lk-restore-password';
        this.sFormAskQuestionClass = '_form-ask-question';
        this.sFormOrderProjectClass = '_form-order-project';
        this.sFormRequestCallClass = '_form-request-call';

        this.sFormMsgErrorClass = '_form-error-msg';
        this.sFormMsgErrorLgClass = '_form-error-msg-lg';
        this.sFormInputErrorTpl = '<div class="_form-error-msg text-red text-xs font-semibold mt-1"></div>';
        this.msg = {
            'empty': 'Заполните поле',
            'emptyCheckbox': 'Обязательное поле',
            'incorect': 'Некорректный формат ',
        };

        this.initHandler();
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener('submit', (obEvent) => {

            //форма изменения пароля
            if(obEvent.target.closest(`.${this.sFormUpdatePasswordClass}`)) {
                obEvent.preventDefault();
                this.updatePasswordSubmit(obEvent);
            }
            //форма оформления заказа
            if(obEvent.target.closest(`.${this.sFormOrderCheckoutClass}`)) {
                obEvent.preventDefault();
                this.orderCheckoutSubmit(obEvent);
            }
    
            //форма регистрации
            if(obEvent.target.closest(`.${this.sFormRegistrationClass}`)) {
                obEvent.preventDefault();
                this.registrationSubmit(obEvent);
            }
    
            //форма личные данные
            if(obEvent.target.closest(`.${this.sFormPersonalDataClass}`)) {
                obEvent.preventDefault();
                this.personalDataSubmit(obEvent);
            }
    
            //форма восстановления пароля
            if(obEvent.target.closest(`.${this.sFormResetPasswordClass}`)) {
                obEvent.preventDefault();
                this.resetPasswordSubmit(obEvent);
            }
    
            //форма сброса пароля
            if(obEvent.target.closest(`.${this.sFormRestorePasswordClass}`)) {
                obEvent.preventDefault();
                this.restorePasswordSubmit(obEvent);
            }
    
            //форма Заказать демонстрацию
            if(obEvent.target.closest(`.${this.sFormRequestDemoClass}`)) {
                obEvent.preventDefault();
                this.magicFormSubmit(obEvent);
            }
    
            //форма задать вопрос
            if(obEvent.target.closest(`.${this.sFormAskQuestionClass}`)) {
                obEvent.preventDefault();
                this.magicFormSubmit(obEvent);
            }
    
            //форма заказать проект
            if(obEvent.target.closest(`.${this.sFormOrderProjectClass}`)) {
                obEvent.preventDefault();
                this.magicFormSubmit(obEvent);
            }
    
            //форма заказать звонок
            if(obEvent.target.closest(`.${this.sFormRequestCallClass}`)) {
                obEvent.preventDefault();
                this.magicFormSubmit(obEvent);
            }
    
            //форма авторизации
            if(obEvent.target.closest(`.${this.sFormAuthClass}`)) {
                obEvent.preventDefault();
                this.authSubmit(obEvent);
            }
        })

        document.addEventListener('change', (obEvent) => {
            //форма если выбрали тип организации
            if (obEvent.target.closest(`${this.sFormOrganizationTypeClass}`)) {
                if(obEvent.target.value == 'entity' && obEvent.target.checked) {
                    obEvent.target.closest(this.sFormClass).querySelector(`.${this.sFormOrganizationFileldsClass}`).style.display = 'block';
                }
                else {
                    obEvent.target.closest(this.sFormClass).querySelector(`.${this.sFormOrganizationFileldsClass}`).style.display = 'none';
                }
            }
        })

    }

    //формы обратной связи
    magicFormSubmit(obEvent) {
        if(this.validate(obEvent)) {
            const _this = this;
            const form = obEvent.target;
            const submitBtn = form.querySelector('[type="submit"]');
            submitBtn.classList.add('_preloader');
            
            request.sendForm(form, 'genericForm::onFormSubmit', {
                success: function(obData) {
                    submitBtn.classList.remove('_preloader');
                    Popup.popupMenuOpen('popup_success', 'Ваша форма была успешно отправлена!');
                },
                error: _this.onError
            });
        }
    }

    updatePasswordSubmit(obEvent) {
        if(this.validate(obEvent)) {

            this.sendForm(obEvent.target, 'ChangePassword::onAjax', (obData) => {
                Popup.popupMenuOpen('popup_success', obData.message);
            })
        }
    }

    resetPasswordSubmit(obEvent) {
        if(this.validate(obEvent)) {

            this.sendForm(obEvent.target, 'ResetPassword::onAjax', (obData) => {
                Popup.popupMenuOpen('popup_success', obData.message);
            })
        }
    }

    restorePasswordSubmit(obEvent) {
        if(this.validate(obEvent)) {

            this.sendForm(obEvent.target, 'RestorePassword::onAjax', (obData) => {
                Popup.popupMenuOpen('popup_success', obData.message, '/');
            })
        }
    }

    orderCheckoutSubmit(obEvent) {
        if(this.validate(obEvent)) {
            this.sendForm(obEvent.target, 'StsMakeOrder::onCreate')
        }
    }

    registrationSubmit(obEvent) {
        if(this.validate(obEvent)) {
            const fields = obEvent.target.elements;
            if (fields['organization_type'].value != 'entity') {
                fields['organization_name'].value = '';
                fields['organization_inn'].value = '';
            }

            this.sendForm(obEvent.target, 'StsRegistration::onAjax', () => {
                if (!this.checkoutOrderAfterAuth()) {
                    Popup.popupMenuOpen('registration_success');
                }
            })
        }
    }

    authSubmit(obEvent) {
        if(this.validate(obEvent)) {
            this.deleteFormMsg(obEvent.target);

            this.sendForm(obEvent.target, 'Login::onAjax', () => {
                if (!this.checkoutOrderAfterAuth()) {
                    location.reload();
                }
            });
        }
    }

    requestDemoSubmit(obEvent) {
        if(this.validate(obEvent)) {
            console.log('валидация прошла успешно - отправка запроса ...');
            alert('валидация прошла успешно - отправка запроса ...');
        }
    }

    orderProjectSubmit(obEvent) {
        if(this.validate(obEvent)) {
            console.log('валидация прошла успешно - отправка запроса ...');
            alert('валидация прошла успешно - отправка запроса ...');
        }
    }

    personalDataSubmit(obEvent) {
        if(this.validate(obEvent)) {
            const fields = obEvent.target.elements;
            if (fields['organization_type'].value != 'entity') {
                fields['organization_name'].value = '';
                fields['organization_inn'].value = '';
            }

            this.sendForm(obEvent.target, 'StsUserPage::onAjax', (obData) => {
                Popup.popupMenuOpen('popup_success', obData.message);
            })
        }
    }

    // отправка формы
    sendForm(form, method, onSuccess, onFail) {
        const _this = this;
        const submitBtn = form.querySelector('[type="submit"]');
        submitBtn.classList.add('_preloader');

        request.sendForm(form, method, {
            success: function(obData, obEvent) {
                submitBtn.classList.remove('_preloader');
                // по умолчанию показываем сообщение об ошибке для поля или формы
                if (obData.status === false) {
                    if (onFail) {
                        onFail(obData);
                    } else {
                        obData?.data?.field
                        ? _this.showInputMsg(obData.message, form.elements[obData.data.field])
                        : _this.showFormMsg(obData.message, form);
                    }
                } else if (obData.status === true) {
                    onSuccess && onSuccess(obData);

                } else if (obData['X_OCTOBER_REDIRECT']) {
                    // если на странице для компонента включен редирект, то вызываем метод октобера
                    this.success(obData, obEvent);
                }
            },
            error: _this.onError,
            update: this.update || {},
        });

        this.update = {};
    }

    onError(...args) {
        console.log(...args);
    }

    //валидация полей форма
    validate(obEvent) {
        let _this = this;
        let isValide = true;

        obEvent.target.closest(this.sFormClass).querySelectorAll('[data-required="true"]').forEach(element => {
            let value = element.value;

            if(isEmpty(value)) {
                //проверка на пустоту
                _this.showInputMsg(_this.msg['empty'], element);
                isValide = false;
            }
            else if(element.getAttribute('name') == "email" && !isEmail(value)) {
                //валидация почты
                if(element.getAttribute('placeholder') == "Логин") {
                    _this.showInputMsg(_this.msg['incorect'] + 'логина', element)
                }
                else {
                    _this.showInputMsg(_this.msg['incorect'] + 'почты', element)
                }
                isValide = false;
            }
            else if(element.getAttribute('name') == "phone" && !isMobilePhone('+' + value.replace(/[^0-9]/g, ''), ['ru-RU'])) {
                //валидация номера телефона
                _this.showInputMsg(_this.msg['incorect'] + 'номера телефона', element)
                isValide = false;
            }
            else if(element.getAttribute('type') == "checkbox" && !element.checked) {
                //валидация checkbox
                _this.showInputMsg(_this.msg['emptyCheckbox'], element)
                isValide = false;
            }
            else {
                _this.deleteInputMsg(element)
            }
        });

        return isValide;
    }

    //отображение ошибки/сообщения для инпута
    showInputMsg(message, input) {
        let div = input.closest('div');

        input.classList.add('border')
        input.classList.add('border-red')

        if(!div.querySelector(`.${this.sFormMsgErrorClass}`)) {
            let sFormInputErrorTpl = document.createElement("div");
            sFormInputErrorTpl.className = "_form-error-msg text-red text-xs font-semibold mt-1";
            div.appendChild(sFormInputErrorTpl)
        }

        div.querySelector(`.${this.sFormMsgErrorClass}`).textContent = message
    }
    //удаление ошибок
    deleteInputMsg(input) {
        input.classList.remove('border')
        input.classList.remove('border-red')
        if(input.closest('div').querySelector(`.${this.sFormMsgErrorClass}`)) {
            input.closest('div').querySelector(`.${this.sFormMsgErrorClass}`).remove()
        }
    }
    //отображение ошибки/сообщения для формы после кнопки
    showFormMsg(message, form) {
        form.querySelector(`.${this.sFormMsgErrorLgClass}`).textContent = message
    }
    //удаление ошибки/сообщения для формы после кнопки
    deleteFormMsg(form) {
        form.querySelector(`.${this.sFormMsgErrorLgClass}`).textContent = ''
    }

    // после регистрации/авторизации переходим к оформлению заказа (в корзине)
    checkoutOrderAfterAuth () {
        if (Popup.nextPopup) {
            const partial = 'form/' + Popup.nextPopup;
            request.sendData('onAjaxRequest', {
                update: {
                    [partial]: `._${Popup.nextPopup}-wrap`,
                },
                success: () => {
                    Popup.popupMenuOpen(Popup.nextPopup);
                }
            })
            return true;
        }

        return false;
    }
}();